module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-left-3.a52fecfb.png";